import { ComplexContentModel } from '@eag/sales-app-base/build/app/core/rest-api/model/complex-content-model';
import { classNames } from 'primereact/utils';

interface Props {
	content: ComplexContentModel;
	className?: string;
}

function SimpleArticleComponent(props: Props) {
	const { content, className } = props;

	return (
		<section className={classNames('login-page-content login-page-article-simple', className)}>
			<div className={'content-block col-12'}>
				<h6>{content.header}</h6>
				{content.body && <div dangerouslySetInnerHTML={{ __html: content.body }} />}
			</div>
		</section>
	);
}

export default SimpleArticleComponent;
